var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid pt-2 mt-1",domProps:{"innerHTML":_vm._s(_vm.partnerContent)}})}
var staticRenderFns = []

export { render, staticRenderFns }